import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { COMMERCIAL_DAMP_MOULD_FAQS } from "@/components/landing/lp-commercial-damp-mould-ventilation";

import { breadcrumbJsonLdScript, commercialBreadcrumbTrail } from "@/lib/breadcrumbs";
import { withServiceLcpPreload } from "@/lib/service-lcp-preload";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

const LpCommercialDampMouldVentilationPage = lazyNamed(
  () => import("@/components/landing/lp-commercial-damp-mould-ventilation"),
  "LpCommercialDampMouldVentilation",
);

const PATH = "/commercial-damp-mould-ventilation";
const TITLE = "Damp, Mould & Ventilation Response | Housing Associations & Councils | CRS Energy";
const DESCRIPTION =
  "Inspection-led damp, mould and whole-house ventilation response for housing associations, councils and landlords. Documented to hazard-response timescales, reported in your format.";
const BREADCRUMB_NAME = "Damp, Mould & Ventilation Response";

export const Route = createFileRoute("/commercial-damp-mould-ventilation")({
  head: () =>
    withServiceLcpPreload(PATH, {
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: BREADCRUMB_NAME,
        description: DESCRIPTION,
        serviceType: "Damp, Mould & Ventilation Response",
        url: `${SITE.url}${PATH}`,
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: COMMERCIAL_DAMP_MOULD_FAQS.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
      breadcrumbJsonLdScript(commercialBreadcrumbTrail(BREADCRUMB_NAME, PATH)),
    ],
  }),
  component: LpCommercialDampMouldVentilationPage,
});
